import { ViewerApi } from "@bronte/viewer-api/src/main";
import { KeyValue } from "../../shared/types";

interface TOCItem {
  id: string;
  type: string;
  title: string;
  children: TOCItem[];
  playOrder: number;
}

export const getTocForMobile = async (viewerApi: ViewerApi) => {
  let firstRenderId: string;
  let tocHtmlNode = "";
  const activityToScreens: KeyValue = {};

  const getHrefElement = (elementId: string, elementTitle: string): string =>
    `<button onclick="route('${elementId}');">${elementTitle}</button>`;

  const appendPathways = (tocData: TOCItem) => {
    const result: any = [];
    tocHtmlNode += `<ul>`;

    tocData?.children.forEach((chapter: TOCItem) => {
      tocHtmlNode += `<li id=${chapter.id}>${getHrefElement(chapter.id, chapter.title || "")}`;

      if (chapter.children) {
        tocHtmlNode += `<ul>`;
        chapter.children.forEach((lesson: TOCItem) => {
          tocHtmlNode += `<li id=${lesson.id}>${getHrefElement(lesson.id, lesson.title || "")}`;

          if (lesson.playOrder) {
            // Set the first lesson id as the first content ID to render for loading.
            if (!firstRenderId) {
              firstRenderId = lesson.id;
            }

            result.push({
              elementId: lesson.id,
              configurationFields: [
                {
                  fieldName: "title",
                  fieldValue: lesson.title,
                },
              ],
            });
          }

          if (lesson.children) {
            tocHtmlNode += `<ul>`;
            lesson.children.forEach((screen: TOCItem) => {
              tocHtmlNode += `<li id=${screen.id}>${getHrefElement(
                screen.id,
                screen.title || "Not Available", //todo: should the title be in ambrosia json?
              )}`;

              if (screen.playOrder) {
                // Set the first screen id as the first content ID to render for loading.
                if (!firstRenderId) {
                  firstRenderId = screen.id;
                }

                result.push({
                  elementId: screen.id,
                  configurationFields: [
                    {
                      fieldName: "title",
                      fieldValue: screen.title,
                    },
                  ],
                });
              }

              tocHtmlNode += `</li>`;
            });

            activityToScreens[lesson.id] = lesson.id;

            tocHtmlNode += `</ul>`;
          }

          tocHtmlNode += `</li>`;
        });

        activityToScreens[chapter.id] = chapter.id;

        tocHtmlNode += `</ul>`;
      }
      tocHtmlNode += `</li>`;
    });

    tocHtmlNode += "</ul>";

    return result;
  };

  const toc = await viewerApi.getCoursewareStructure();

  let screens = [];

  return () => {
    //@ts-ignore
    screens = [...appendPathways(toc)];

    return {
      tocHtmlNode,
      firstRenderId,
      screens,
      activityToScreens,
    };
  };
};
